import { AsyncThunkAction } from "@reduxjs/toolkit"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../store/hooks"
import { refreshtoken, sesisonExpired } from "../store/user"


const useFetchtoken = (action: AsyncThunkAction<any, any, any>) => {
  const {timelogin} = useAppSelector(state=> state.user)
  const dispatch = useAppDispatch()
  useEffect(() => {
    const promiseAction = dispatch(action)
    promiseAction.then((response:any)=>{
      if(response.error?.message === 'Request failed with status code 508'){
        dispatch(sesisonExpired())
      }
      if (response.meta.requestStatus === 'fulfilled'){
        if(timelogin +  8.46e+7/*2.7e+6 30000 */< Date.now() ){
          dispatch(refreshtoken())
        }
      }
    })
    return () => {
      promiseAction.abort()
    };
  },[]);
  return{
  }
}
export default useFetchtoken